// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Neewerai-version_ruleForm[data-v-d71c1b36] {\n  width: 100%;\n  max-width: 760px;\n  margin: 0 auto;\n}\n.Neewerai-version_ruleForm .ant-form-item-children[data-v-d71c1b36],\n.Neewerai-version_ruleForm .ant-calendar-picker[data-v-d71c1b36] {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
